module.exports = __webpack_public_path__ + "img/github.67910a24.svg";